/**
 * This component is used for both the stream cap ad and the in-story ad.
 */

import React from "react";
import Ad from "components/Library/Ad";
import styles from "./HeadlineAd.css";
import PropTypes from "prop-types";

import { Waypoint } from "react-waypoint";
import { adInViewDataLayerEvent } from "utils/analytics";

const HeadlineAd = ({ adUnit, adType, targeting }) => {
  return (
    <Waypoint onEnter={() => adInViewDataLayerEvent(adType)}>
      <div className={styles[adType]}>
        <Ad
          adUnit={adUnit}
          slotSize="fluid"
          renderWhenViewable={false}
          collapseEmptyDiv={true}
          targeting={targeting}
        />
      </div>
    </Waypoint>
  );
};

HeadlineAd.propTypes = {
  adUnit: PropTypes.string,
  targeting: PropTypes.object.isRequired,
  adType: PropTypes.string.isRequired,
};

HeadlineAd.defaultProps = {
  adUnit: "axios",
  targeting: { pos: "mid0", kwAfter: "" },
};

export default HeadlineAd;
